// ============================================
// CONFIGURACIÓN RÁPIDA DE PUERTALIA PORTAL
// ============================================

// 👉 ENLACE DE GOOGLE PLAY: pega aquí la URL de tu app cuando la tengas.
//    Mientras tanto es "#" (no lleva a ningún sitio).
export const GOOGLE_PLAY_URL = "#";

// WhatsApp de contacto (todo el contacto va por aquí)
export const WHATSAPP_NUMBER_DISPLAY = "722 18 89 16";
export const WHATSAPP_MESSAGE = "Hola, quiero información sobre Puertalia Portal";
export const WHATSAPP_URL = `https://wa.me/34722188916?text=${encodeURIComponent(WHATSAPP_MESSAGE)}`;

// Opiniones de ejemplo: sustitúyelas por las reales cuando las tengas.
export const REVIEWS = [
    {
        name: "María G.",
        city: "Valencia",
        text: "Encontré un piso en Valencia en menos de una semana. Todo clarísimo desde el primer mensaje y la visita fue en persona, sin pedirme nada por adelantado.",
    },
    {
        name: "Javier R.",
        city: "Sevilla",
        text: "La app va muy rápida y los precios son de verdad mejores que en otros portales. Me atendieron por WhatsApp al momento, se agradece el trato directo.",
    },
    {
        name: "Lucía P.",
        city: "Madrid",
        text: "Alquilé un estudio en Madrid con ellos. Se nota que los anuncios los lleva su propio equipo: fotos reales, información completa y cero sorpresas.",
    },
];
